import {defaultState} from './state';
import * as ValidationActions from '../actions/ValidationActions';
import * as CalculatorActions from '../actions/CalculatorActions';

const globalValidations = (state = defaultState.globalValidations, action) => {

    switch (action.type) {
        case ValidationActions.GOT_MIN_ALLOWED_AGE_ACTION.name:
            return {
                ...state,
                creditoReal:{
                    ...state.creditoReal,
                    minAllowedAge: action.minAllowedAgeCR
                },
                turboCash:{
                    ...state.turboCash,
                    minAllowedAge: action.minAllowedAgeTC
                }
            };
        case ValidationActions.GOT_MIN_ALLOWED_VEHICLE_PRICE_ACTION.name:
            return {
                ...state,
                creditoReal:{
                    ...state.creditoReal,
                    minAllowedVehiclePrice: action.minAllowedVehiclePriceCR
                },
                turboCash:{
                    ...state.turboCash,
                    minAllowedVehiclePrice: action.minAllowedVehiclePriceTC
                }
            };
        case ValidationActions.GOT_MIN_DOWN_PAYMENT_ACTION.name:
            return {
                ...state,
                creditoReal:{
                    ...state.creditoReal,
                    minDownPayment: action.minDownPaymentCR
                },
                turboCash:{
                    ...state.turboCash,
                    minDownPayment: action.minDownPaymentTC
                }
            };
        case CalculatorActions.GOT_SIMULATOR_PROFILE_MX_ACTION.name:
            return {
                ...state,
                configByProfile:{
                    ...state.configByProfile,
                    minDownPayment: action.creditConditions.minRate,
                    maxDownPayment: action.creditConditions.maxRate,
                    monthlyRate: action.creditConditions.rate
                }
            };
        case ValidationActions.GOT_MAX_DOWN_PAYMENT_ACTION.name:
            return {
                ...state,
                creditoReal:{
                    ...state.creditoReal,
                    maxDownPayment: action.maxDownPaymentCR
                },
                turboCash:{
                    ...state.turboCash,
                    maxDownPayment: action.maxDownPaymentTC
                }
            };
        case ValidationActions.GOT_SMS_TIMER_RESEND_ACTION.name:
            return {
                ...state,
                smsTimerResend: action.smsTimerResend
            };
        default:
            return state;
    }
};

export default globalValidations;